import { lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { IconaTutorial } from '@/components/tutorial/IconaTutorial';
import { chiaveTutorialVisto } from '@/lib/storage';

import { GiocaGinRummy } from './GiocaGinRummy';
import { TavoliMieiGinRummy } from './TavoliMieiGinRummy';

/**
 * Il livello del tutorial, pigro: un chunk a parte che si scarica solo quando si apre. L'annotazione PURE e` NECESSARIA (`IconaTutorial.tsx`). Questo file lo monta SOLO `HubSections` e la rotta
 * dentro il confronto letterale del flag: in produzione ne' la Hub ne' il chunk ci sono (`tools/verify-ginrummy.ts` sez. 15 e `npm run verify:ginrummy-bundle`).
 */
const LivelloLazy = /*#__PURE__*/ lazy(() =>
  import('./TutorialGinRummy').then((m) => ({ default: m.TutorialGinRummy })),
);

/**
 * La Hub del gin rummy (sul modello di `HubScopa`): col gioco attivo = Gin Rummy la Hub non ha la riga delle sezioni, ha DUE blocchi — «Gioca» (Gioca, Invita un amico, Entra con un
 * codice) e «I miei tavoli / Riprendi» — dentro UN solo scorrevole. Ranked e tornei vengono dopo. La stessa Hub e la pagina `/ginrummy` (`routes/ginrummy/GinRummyHome.tsx`).
 *
 * ⚠️ Lo montano `HubSections` e la rotta SOLO dentro il confronto LETTERALE del flag `VITE_FEATURE_GINRUMMY_ENABLED` (che il bundler piega): questo file e il marcatore
 * `data-hub-ginrummy` non sono in produzione. La serratura (`beta`, Limulo acceso) sta in `HubSections`, nel selettore e nel `RoleGate` della rotta.
 */
export function HubGinRummy() {
  const { t } = useTranslation('ginrummy');
  return (
    <div
      data-hub-ginrummy
      className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain py-2 [touch-action:pan-y]"
    >
      {/* il tutorial (I-1218): l'icona sta solo qui, nella Hub, mai in una partita ne' nell'Attesa; una chiave sola sul dispositivo */}
      <div data-riga-tutorial-ginrummy className="flex shrink-0 justify-end px-2">
        <IconaTutorial
          Livello={LivelloLazy}
          chiave={chiaveTutorialVisto('ginrummy')}
          nome={t('tutorial.icona.nome')}
          nuovo={t('tutorial.icona.nuovo')}
        />
      </div>
      <GiocaGinRummy />
      <TavoliMieiGinRummy />
    </div>
  );
}
